import React from 'react';
import PropTypes from 'prop-types';

const CheckMark = ({ colour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="17"
    viewBox="0 0 21 17"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-6-9h32v33H-6z" />
      <path
        fill={colour}
        fillRule="nonzero"
        d="M0 10.413l2.075-2.1L6.25 12.5 18.75 0l2.087 2.075L6.25 16.663z"
      />
    </g>
  </svg>
);

CheckMark.propTypes = {
  colour: PropTypes.string
};

CheckMark.defaultProps = {
  colour: '#8142FF'
};

export default CheckMark;
